/** The advance payment requests are blocked for the previous month after this day */
export const PAY_BLOCK_DATE = 2;

/**
 * Advance payment request statuses that are still "in progress" (not finalized):
 * a talent should not be blocked, or block silently, while one of these is ongoing.
 */
export const ADVANCE_PAYMENT_REQUEST_IN_PROGRESS_STATUSES = [
  "pending",
  "pending_transfer_confirmation",
  "paid",
] as const;

export const MIN_AMOUNT_IN_CENTS_FOR_HRIS_ADVANCE_PAYMENT_REQUEST = 100_00;
/** A talent may raise at most this many live HRIS (manual) requests for one pay month within a week. */
export const MAX_HRIS_ADVANCE_PAYMENT_REQUESTS_PER_MONTH_PER_WEEK = 2;
export const MIN_AMOUNT_IN_CENTS_FOR_ADVANCE_PAYMENT_REQUEST_PRODUCTION = 50_00;
export const MIN_AMOUNT_IN_CENTS_FOR_ADVANCE_PAYMENT_REQUEST_STAGING = 10_00;
export const MAX_AMOUNT_IN_CENTS_FOR_ADVANCE_PAYMENT_REQUEST = 2_000_00;
